import { useState } from 'react';
import { Common } from '@thecvlb/design-system/lib/src';

import Heading from 'pages/SignUp/components/Heading';

import DropFiles from '../DropFiles/DropFiles';

const UploadImages = () => {
  const [isUploaded, setIsUploaded] = useState(false);
  return (
    <>
      <Heading
        category=""
        subtitle="Please upload an image of your current medication to help us verify your prescription."
        title="Great! Let’s verify your medication."
      />
      <DropFiles onSuccessfulUpload={() => setIsUploaded(true)} />
      <Common.Button
        className="mt-auto self-center"
        color="blue"
        disabled={isUploaded}
        fullWidthOnMobile
      >
        Continue
      </Common.Button>
    </>
  );
};

export default UploadImages;
